import {
  CommonParamsType,
  CommonSuccessResponse,
} from "constants/types/common";
import { MeasurementUnitResponse } from "constants/types/measurement";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const getMeasurementUnitListKey = (params?: CommonParamsType) => {
  return `/measurement-unit?${serialize({ ...params })}`;
};

export const useMeasurementUnits = (params?: CommonParamsType) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<MeasurementUnitResponse[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(getMeasurementUnitListKey(params), { refreshInterval: 0 });

  const pagination = data?.meta;
  const measurementUnits = data?.data;

  return {
    measurementUnits,
    pagination,
    error,
    isLoading,
    mutate,
  };
};

export const useListMeasurementUnit = () => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<MeasurementUnitResponse[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR("/measurement-unit/all", { refreshInterval: 0 });

  const measurementList = data?.data;

  const measurementOptions = measurementList?.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  return {
    measurementOptions,
    error,
    isLoading,
    mutate,
  };
};
